import { render, staticRenderFns } from "./AssistantCard.vue?vue&type=template&id=feddba9e&scoped=true&"
import script from "./AssistantCard.vue?vue&type=script&lang=js&"
export * from "./AssistantCard.vue?vue&type=script&lang=js&"
import style0 from "./AssistantCard.vue?vue&type=style&index=0&id=feddba9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feddba9e",
  null
  
)

export default component.exports